import { loadScript } from '../load-strategies/LineShareSdkLoader';

export type { ILineShareSDK } from '../load-strategies/LineShareSdkLoader';

export default {
  name: 'lineShare',
  loader: loadScript,
};
